var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/Favorite_Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9986123,19.3452501 L7.5796123,21.6562501 C5.7646123,22.6052501 4.1966123,21.4692501 4.5436123,19.4532501 L5.3866123,14.5652501 L1.8156123,11.1022501 C0.342612302,9.6732501 0.945612302,7.8322501 2.9746123,7.5382501 L7.9146123,6.8242501 L10.1226123,2.3732501 C11.0306123,0.541250102 12.9676123,0.543250102 13.8746123,2.3732501 L16.0826123,6.8242501 L21.0226123,7.5382501 C23.0536123,7.8322501 23.6536123,9.6742501 22.1816123,11.1022501 L18.6106123,14.5652501 L19.4536123,19.4532501 C19.8016123,21.4712501 18.2306123,22.6042501 16.4176123,21.6562501 L11.9986123,19.3452501 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16x16/Favorite_Fill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "shape",
    fill: "#FFC542",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFill);
export default __webpack_public_path__ + "static/media/Favorite_Fill.643acc14a852b92b889a309af02ebabd.svg";
export { ForwardRef as ReactComponent };